// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-article-js": () => import("/home/deploy/guide/src/templates/Article.js" /* webpackChunkName: "component---src-templates-article-js" */),
  "component---src-pages-404-jsx": () => import("/home/deploy/guide/src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-pages-index-jsx": () => import("/home/deploy/guide/src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */)
}

